import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { BiButton } from '../../components/ui/BiButton';
import { BiAudienceLine } from './functions/biAudience';

/**
 * The confirm step, in place inside the panel: who will reach the
 * dashboard once saved, before anything is written.
 */
export const AudienceConfirm = memo(
  ({
    lines,
    error,
    busy,
    onBack,
    onConfirm,
  }: {
    lines: BiAudienceLine[];
    error: string | null;
    busy: boolean;
    onBack: () => void;
    onConfirm: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ gap: rpx(12) }}>
        <Typography.Text medium size={rpx(14)} color={aiColors.foreground}>
          确认后，这些人可以看到这个看板：
        </Typography.Text>
        <View
          style={{
            padding: rpx(12),
            gap: rpx(8),
            borderRadius: rpx(12),
            backgroundColor: aiColors.muted,
          }}
        >
          {lines.map(line => (
            <View
              key={line.who}
              style={{ flexDirection: 'row', justifyContent: 'space-between' }}
            >
              <Typography.Text size={rpx(13)} color={aiColors.foreground}>
                {line.who}
              </Typography.Text>
              <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
                {line.can}
              </Typography.Text>
            </View>
          ))}
        </View>
        <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
          每个人看到的是自己权限范围内的数据；角色不能查看的图表只显示标题。
        </Typography.Text>
        {error ? (
          <Typography.Text size={rpx(12)} color={aiColors.destructive}>
            {error}
          </Typography.Text>
        ) : null}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-end',
            gap: rpx(8),
          }}
        >
          <BiButton title="返回修改" onPress={onBack} />
          <BiButton
            title="确认共享"
            tone="primary"
            loading={busy}
            onPress={onConfirm}
          />
        </View>
      </View>
    );
  },
);
